import React, { CSSProperties, DetailedHTMLProps } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useHistory } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import noop from 'utils/noop';
import SideMenuItem from '../parts/SideMenuItem';
import { dashboardOptions, logoutOptions, SideMenuOptionsType } from '../sideMenuOptions';

import styles from './SideMenu.module.css';

import swipeIcon from 'assets/icons/side-menu/swipe.svg';
import logo from 'assets/icons/sidemenus-PNG/fab_logo_white.png';

interface IThumbV extends DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  style: CSSProperties
}

function SideMenu() {
  const thumbV = ({ style, ...props }: IThumbV) => (
    <div className={styles.thumbV} style={{ ...style }} {...props} />
  );

  const renderItem = (option: SideMenuOptionsType) => (
    <SideMenuItem
      key={option.name}
      {...option}
    />
  );

  const history = useHistory();
  const onLogoClick = () => {
    history.push(routePaths.dashboard);
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.title}
        role="button"
        tabIndex={0}
        onClick={onLogoClick}
        onKeyPress={noop}
      >
        <img src={logo} alt="fab-logo" className={styles.logo} />
        <span className={styles.companyName}>First Atlantic Bank PLC</span>
        <div className={styles.shadowTop} />
      </div>
      <nav className={styles.nav}>
        <Scrollbars
          renderThumbVertical={thumbV}
        >
          {dashboardOptions().map(renderItem)}
        </Scrollbars>
        <div className={styles.shadowBottom} />
      </nav>
      <div className={styles.swipe}>
        <img src={swipeIcon} alt="swipe-logo" className={styles.swipeIcon} />
        <span className={styles.swipeText}>Swipe</span>
      </div>
      <SideMenuItem {...logoutOptions} className={styles.logout} />
    </div>
  );
}

export default SideMenu;
